import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import Sticky from 'react-stickynode'
import { me } from '../initial_state'
import {
  BREAKPOINT_EXTRA_SMALL,
  CX,
} from '../constants'
import SidebarPanelGroup from '../components/sidebar_panel_group'
import WrappedBundle from '../features/ui/util/wrapped_bundle'
import {
  LinkFooter,
  GabAdTopPanel,
  GabAdBottomPanel,
  ExploreTimeline,
} from '../features/ui/util/async_components'
import { connect } from 'react-redux'
import DefaultNavigationBar from '../components/navigation_bar/default_navigation_bar'
import LoggedOutNavigationBar from '../components/navigation_bar/logged_out_navigation_bar'
import Button from '../components/button'
import Text from '../components/text'
import Input from '../components/input'
import RandomSidebarPanels from '../components/sidebar/random_sidebar_panels'
import HomeCallToAction from '../components/home_call_to_action'

class LandingLayout extends ImmutablePureComponent {

  render() {
    const {
      width,
    } = this.props
    
    const isXS = width <= BREAKPOINT_EXTRA_SMALL
    const titleFontSize = isXS ? '38px' : '56px'
    const subtitleFontSize = isXS ? _s.fs16PX : _s.fs19PX

    const leftContainerClasses = CX({
      d: 1,
      flexShrink1: 1,
      pr15: !isXS,
      px15: isXS,
    })

    const timelineTitleContainerClasses = CX({
      d: 1,
      mb15: 1,
      py10: 1,
      aiCenter: 1,
      aiStart: isXS,
      flexRow: 1,
      flexWrap: isXS,
      px10: isXS,
    })

    const items = RandomSidebarPanels()
    const sidebarLayout = [
      <WrappedBundle key='landing-home-page-ad-panel' component={GabAdTopPanel} componentParams={{ pageKey: 'landing-home.sidebar', position: 1 }} />,
      ...items,
      LinkFooter,
      <WrappedBundle key='landing-home-page-ad-panel-bottom' component={GabAdBottomPanel} componentParams={{ pageKey: 'landing-home.sidebar', position: 1 }} />
    ]

    return (
      <div className={[_s.d, _s.w100PC, _s.minH100VH, _s.bgTertiary].join(' ')}>
        { !!me && <DefaultNavigationBar page='home' title='Home' /> }
        { !me && <LoggedOutNavigationBar title='Home' /> }

        <div className={[_s.d, _s.w100PC].join(' ')}>
          <main role='main'>

            <div className={[_s.d, _s.w100PC, _s.minH260PX, _s.bgPrimary, _s.jcCenter, _s.aiCenter,  _s.w100PC, _s.borderBottom3PX, _s.borderColorBrand].join(' ')}>
              <div className={[_s.d, _s.w1255PX, _s.overflowHidden, _s.mlAuto, _s.mrAuto, _s.flexRow].join(' ')}>
                <div className={leftContainerClasses}>
                  <h1 className={[_s.d, _s.font, _s.cPrimary, _s.mb15, _s.mt5, _s.fw700].join(' ')} style={{ fontSize: titleFontSize }}>Gab.com</h1>
                  <h2 className={[_s.d, _s.text, _s.cSecondary, _s.wrap, _s.overflowWrapBreakWord, _s.fw500, _s.mb5, subtitleFontSize].join(' ')}>The Free Speech Social Network and Pioneer of The Parallel Economy.</h2>
                  {/* <h3 className={[_s.d, _s.text, _s.cSecondary, _s.wrap, _s.overflowWrapBreakWord, _s.fw500, _s.mb15, subtitleFontSize].join(' ')}>Join our community where people who support family, faith and free speech can speak freely and shop at businesses that share their values.</h3> */}
                </div>
                {
                  !isXS &&
                  <div className={[_s.d, _s.w380PX, _s.mlAuto].join(' ')}>
                    <div className={[_s.d, _s.w100PC, _s.bgPrimary, _s.boxShadowBlock, _s.aiCenter, _s.jcCenter, _s.border1PX, _s.px15, _s.py15, _s.radiusSmall, _s.borderColorInput].join(' ')}>
                      <Input
                        placeholder='Email address'
                        className={[_s.w100PC].join(' ')}
                      />
                      <Button
                        isBlock
                        radiusSmall
                        className={[_s.aiCenter, _s.jcCenter, _s.mt10].join(' ')}
                        href='/auth/sign_in'
                      >
                        <Text color='inherit' weight='bold' align='center' size='extraLarge'>Log In</Text>
                      </Button>
                      <Button
                        isBlock
                        radiusSmall
                        isOutline
                        color='brand'
                        backgroundColor='none'
                        className={[_s.aiCenter, _s.jcCenter, _s.mt10].join(' ')}
                        href='/auth/sign_up'
                      >
                        <Text color='inherit' weight='bold' align='center' size='extraLarge'>Create new account</Text>
                      </Button>
                      {/* <Button
                        isBlock
                        radiusSmall
                        color='brand'
                        backgroundColor='none'
                        className={[_s.aiCenter, _s.jcCenter, _s.mt10].join(' ')}
                        href='/marketplace/business/join'
                      >
                        <Text color='inherit' weight='bold' align='center' size='medium'>Create a page for your Business</Text>
                      </Button> */}
                    </div>
                  </div>
                }
              </div>
            </div>
            
            <div className={[_s.d, _s.w1255PX, _s.mlAuto, _s.mrAuto, _s.pt15].join(' ')}>

              {/* Explore timeline */}
              <div className={[_s.d, _s.w1015PX, _s.mlAuto, _s.mrAuto].join(' ')}>

                <div className={timelineTitleContainerClasses}>
                  <Text color='secondary' weight='bold' size='extraLarge' className={[_s.mr15].join(' ')}>
                    Top Posts on Gab Right Now
                  </Text>
                  <Button
                    radiusSmall
                    isOutline
                    isNarrow
                    backgroundColor='none'
                    color='brand'
                    to='/timeline/pro'
                    className={isXS ? [_s.mt10].join(' ') : [_s.mlAuto].join(' ')}
                    >
                    <Text weight='bold' size='medium' color='inherit'>View all Timelines</Text>
                  </Button>
                </div>

                <div className={[_s.d, _s.w1015PX, _s.z1, _s.mlAuto, _s.mrAuto].join(' ')}>
                  <main role='main'>
                    <div className={[_s.d, _s.w100PC, _s.mlAuto, _s.mrAuto, _s.flexRow, _s.jcEnd, _s.py10].join(' ')}>
                    
                      <div className={[_s.d, _s.w645PX, _s.z1, _s.mlAuto, _s.mrAuto].join(' ')}>
                        <div className={_s.d}>
                          <HomeCallToAction isXS={isXS} />

                          <WrappedBundle component={ExploreTimeline} />
                        </div>
                      </div>
                      
                      {
                        !isXS &&
                        <div className={[_s.d, _s.w340PX].join(' ')}>
                          <Sticky top={73} enabled>
                            <div className={[_s.d, _s.w340PX, _s.pl15].join(' ')}>
                              <SidebarPanelGroup layout={sidebarLayout} page={'explore-home'} />
                            </div>
                          </Sticky>
                        </div>
                      }

                    </div>
                  </main>
                </div>
              </div>


            </div>

          </main>
        </div>
      </div>
    )
  }

}

const mapStateToProps = (state) => ({
  width: state.getIn(['settings', 'window_dimensions', 'width']),
})

LandingLayout.propTypes = {
  actions: PropTypes.array,
  children: PropTypes.node,
  group: ImmutablePropTypes.map,
  groupId: PropTypes.string,
  layout: PropTypes.object,
  relationships: ImmutablePropTypes.map,
  title: PropTypes.string,
  noRightSidebar: PropTypes.bool,
}

export default connect(mapStateToProps)(LandingLayout)
